import React from 'react';
import { Star } from 'lucide-react';
import { RegistrationForm } from '../components/auth/RegistrationForm';

export const SignUpPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <Star className="w-12 h-12 text-purple-300 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-purple-200">Criar Conta</h2>
          <p className="text-purple-200/70">Comece sua jornada astral</p>
        </div>

        <RegistrationForm />
      </div>
    </div>
  );
};